import React from 'react'

function HorizontalDots() {
  return (
    <>
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M2.82353 7.49991C2.08235 7.49991 1.5 8.0955 1.5 8.82344C1.5 9.55138 2.09559 10.147 2.82353 10.147C3.55147 10.147 4.14706 9.55138 4.14706 8.82344C4.14706 8.0955 3.56471 7.49991 2.82353 7.49991Z'
          fill='#707070'
        />
        <path
          d='M8.4705 7.49991C7.72933 7.49991 7.14697 8.0955 7.14697 8.82344C7.14697 9.55138 7.74256 10.147 8.4705 10.147C9.19844 10.147 9.79403 9.55138 9.79403 8.82344C9.79403 8.0955 9.21168 7.49991 8.4705 7.49991Z'
          fill='#707070'
        />
        <path
          d='M14.1175 7.49991C13.3763 7.49991 12.7939 8.0955 12.7939 8.82344C12.7939 9.55138 13.3895 10.147 14.1175 10.147C14.8454 10.147 15.441 9.55138 15.441 8.82344C15.441 8.0955 14.8587 7.49991 14.1175 7.49991Z'
          fill='#707070'
        />
      </svg>
    </>
  )
}

export default HorizontalDots
